import { render, staticRenderFns } from "./UserDeleteDialog.vue?vue&type=template&id=9e1ef106&"
import script from "./UserDeleteDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./UserDeleteDialog.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports